"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CryptoServiceFee = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CryptoServiceFee = function CryptoServiceFee(_ref) {
  var isInternalAddress = _ref.isInternalAddress;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var text = isInternalAddress ? 'internalServiceFeeTooltip' : 'serviceFeeTooltip';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t(text, {
    serviceName: '0xpay'
  }));
};
exports.CryptoServiceFee = CryptoServiceFee;